<template>
    <div>
        <BreadcrumbRow :items="breadcrumbItems"/>

        <RowColumn v-if="canPurchaseProducts()">
            <ButtonTag :is-w100="false" url="products/0/purchase"> {{ $t('purchase') }}</ButtonTag>
        </RowColumn>

        <div class="row">
            <div class='col'>

                <!--                ProductsList component-->
                <table class="table  table-striped mt-3"  >
                    <thead>
                    <tr v-for="(objects, index) in getWarehouse.productInWarehouses" :key="index">{{objects.name}}</tr>
                    <tr>
                        <th scope="col" class="d-none d-sm-block">#</th>
                        <th scope="col">{{ $t('product.title') }}</th>
                        <th scope="col">{{ $t('amount') }}</th>
                        <th scope="col" class="d-none d-sm-block">{{ $t('unitOfMeasure.short') }}</th>
                        <th scope="col">{{ $t('actions') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(objects, index) in getWarehouse.productInWarehouses" :key="index">
                        <th scope="row" class="d-none d-sm-block">{{ objects.product.id }}</th>
                        <td><router-link :to="$i18nHelper.getUrl('products/' + objects.product.id)">
                            {{ objects.product.name }}</router-link></td>
                        <td>{{ objects.amount }}</td>
                        <td class="d-none d-sm-block">{{ objects.product.unitOfMeasure }}</td>
                        <td>
                            <button
                                v-if="canPurchaseProducts()"
                                class="btn btn-success btn-sm"
                                data-toggle="tooltip"
                                :title="$t('purchase')"
                                @click="$i18nHelper.toUrl('products/' + objects.product.id +'/purchase/')
                            ">
                                <font-awesome-icon :icon="['fa', 'plus']"/>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>
        </div>


    </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import BreadcrumbRow from "@/components/BreadcrumbRow";
import RowColumn from "@/components/RowColumn";
import ButtonTag from "@/components/html/ButtonTag";
import accessMixin from "@/mixin/accessMixin";

export default {
    name: "Show",
    computed: mapGetters({
        getWarehouse: 'getWarehouse',
    }),
    mixins: [accessMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'product.title'},
            ],
        }
    },
    methods: {
        ...mapActions(['fetchWarehouse']),
    },
    components: {
        ButtonTag,
        RowColumn,
        BreadcrumbRow,
    },
    mounted() {
        this.fetchWarehouse(this.$route.params.id)
    }
}
</script>

<style scoped>

</style>
